import {useEffect, useState} from 'react';

import {LocalStorage} from '../../utils/LocalStorage';
import {getLearningState, refreshLearning, subscribeLearning} from './learnStore';
import {ownerKey} from './state/learnMemory';

/**
 * El estado de «Aprende Dashbo» (`learnStore`), y pedirlo al montarse.
 *
 * `active`: sólo se pide con la 2.1 cargada (`ficha21 && loaded`). En el marco clásico no hay ni
 * entrada ni lanzador, y una persona sin la 2.1 no tiene por qué pagar el pedido.
 *
 * El pedido al montar va con la copia de 30 s del `APIClient`: el marco se monta en cada navegación
 * y la entrada del menú, el lanzador y la pantalla de Usuarios piden lo mismo en el mismo tick. La
 * página pide fresco por su cuenta.
 */
export function useLearning({active = true} = {}) {
    const [snapshot, setSnapshot] = useState(getLearningState);
    // Quién mira, leído en cada render: justo después del login la agencia todavía no está y el store
    // no pide nada (`ownerKey` da `null`). Cuando llega —el marco se vuelve a pintar con los datos del
    // usuario— el efecto corre de nuevo y pide.
    const owner = ownerKey(LocalStorage.fetchUserId(), LocalStorage.fetchAgencyId());

    useEffect(() => {
        if (!active) return undefined;
        const unsubscribe = subscribeLearning(setSnapshot);
        setSnapshot(getLearningState());
        refreshLearning();
        return unsubscribe;
    }, [active, owner]);

    return snapshot;
}
